import React from 'react';
import { useTranslation } from 'react-i18next';

import { RecursiveMenuMaxMenu } from '@uncinc/react-drupal-core';
import type { RecursiveMenuMaxMenuProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import './style.scss';

type MainMenuProps = Omit<RecursiveMenuMaxMenuProps, 'className' | 'menuId' | 'bookId' | 'navProps' | 'menuItemWrapperWrapperClasses'>;

const MainMenu: React.FC<MainMenuProps> = (props) => {
  const { t } = useTranslation();

  return (
    <RecursiveMenuMaxMenu
      {...props}
      className="MainMenu"
      menuId="main"
      navProps={{ 'aria-label': t('nav.main') }}
      menuItemWrapperWrapperClasses="col-12"
    />
  );
};

export default MainMenu;
